import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import api from '../api';

export default function Einstellungen() {
  const { user } = useAuth();
  const [form, setForm] = useState({ altes_passwort: '', neues_passwort: '', bestaetigung: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleChange = (e) => {
    setForm(prev => ({ ...prev, [e.target.name]: e.target.value }));
    setError(''); setSuccess('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.altes_passwort || !form.neues_passwort) { setError('Alle Felder sind Pflicht'); return; }
    if (form.neues_passwort.length < 8) { setError('Neues Passwort muss mindestens 8 Zeichen lang sein'); return; }
    if (form.neues_passwort !== form.bestaetigung) { setError('Neues Passwort und Bestätigung stimmen nicht überein'); return; }

    setLoading(true);
    try {
      await api.put('/api/auth/password', { altes_passwort: form.altes_passwort, neues_passwort: form.neues_passwort });
      setSuccess('Passwort erfolgreich geändert');
      setForm({ altes_passwort: '', neues_passwort: '', bestaetigung: '' });
    } catch (err) {
      setError(err.response?.data?.error || 'Fehler beim Ändern des Passworts');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div className="page-header">
        <h2 className="page-title">Einstellungen</h2>
      </div>

      <div style={{ display: 'grid', gap: '1rem', maxWidth: 600 }}>
        <div className="card">
          <h3 style={{ fontWeight: 700, marginBottom: '1rem', color: 'var(--primary)' }}>Mein Konto</h3>
          <div className="detail-grid">
            <div className="detail-item"><div className="detail-label">Name</div><div className="detail-value">{user?.vorname} {user?.nachname}</div></div>
            <div className="detail-item"><div className="detail-label">E-Mail</div><div className="detail-value">{user?.email}</div></div>
            <div className="detail-item"><div className="detail-label">Rolle</div><div className="detail-value" style={{ textTransform: 'capitalize' }}>{user?.rolle}</div></div>
          </div>
        </div>

        <div className="card">
          <h3 style={{ fontWeight: 700, marginBottom: '1rem', color: 'var(--primary)' }}>Passwort ändern</h3>

          {error && <div className="alert alert-error">{error}</div>}
          {success && <div className="alert alert-success">{success}</div>}

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label className="form-label">Aktuelles Passwort</label>
              <input type="password" name="altes_passwort" value={form.altes_passwort} onChange={handleChange}
                className="form-control" autoComplete="current-password" />
            </div>
            <div className="form-group">
              <label className="form-label">Neues Passwort (min. 8 Zeichen)</label>
              <input type="password" name="neues_passwort" value={form.neues_passwort} onChange={handleChange}
                className="form-control" autoComplete="new-password" />
            </div>
            <div className="form-group">
              <label className="form-label">Neues Passwort bestätigen</label>
              <input type="password" name="bestaetigung" value={form.bestaetigung} onChange={handleChange}
                className="form-control" autoComplete="new-password" />
            </div>
            <button type="submit" className="btn btn-primary" disabled={loading} style={{ marginTop: '0.5rem' }}>
              {loading ? 'Speichern…' : 'Passwort ändern'}
            </button>
          </form>
        </div>

        {user?.rolle === 'admin' && <EmailKonfiguration />}
      </div>
    </div>
  );
}

function EmailKonfiguration() {
  const [config, setConfig] = useState(null);
  const [form, setForm] = useState({
    smtp_host: '', smtp_port: '587', smtp_secure: false,
    smtp_benutzer: '', smtp_passwort: '',
    absender_name: '', absender_email: '', aktiv: false,
    vereinsname: 'SV Grevenbroich e.V.', logo_base64: '',
    kontakt_name: '', kontakt_email: '', aufnahmeantrag_url: '',
  });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [testing, setTesting] = useState(false);
  const [testAn, setTestAn] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [testMsg, setTestMsg] = useState('');

  useEffect(() => {
    api.get('/api/admin/email-konfiguration')
      .then(r => {
        setConfig(r.data);
        setForm(prev => ({
          ...prev,
          smtp_host: r.data.smtp_host || '',
          smtp_port: String(r.data.smtp_port || 587),
          smtp_secure: !!r.data.smtp_secure,
          smtp_benutzer: r.data.smtp_benutzer || '',
          smtp_passwort: '',
          absender_name: r.data.absender_name || '',
          absender_email: r.data.absender_email || '',
          aktiv: !!r.data.aktiv,
          vereinsname: r.data.vereinsname || 'SV Grevenbroich e.V.',
          logo_base64: r.data.logo_base64 || '',
          kontakt_name: r.data.kontakt_name || '',
          kontakt_email: r.data.kontakt_email || '',
          aufnahmeantrag_url: r.data.aufnahmeantrag_url || '',
        }));
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const handleChange = e => {
    const { name, value, type, checked } = e.target;
    setForm(prev => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
    setError(''); setSuccess('');
  };

  const handleSave = async (e) => {
    e.preventDefault();
    setSaving(true); setError(''); setSuccess('');
    try {
      await api.put('/api/admin/email-konfiguration', form);
      setSuccess('Konfiguration gespeichert.');
    } catch (err) {
      setError(err.response?.data?.error || 'Fehler beim Speichern');
    } finally {
      setSaving(false);
    }
  };

  const handleTest = async () => {
    if (!testAn) return;
    setTesting(true); setTestMsg('');
    try {
      const r = await api.post('/api/admin/email-konfiguration/test', { an: testAn });
      setTestMsg(r.data.message || 'Test-E-Mail gesendet.');
    } catch (err) {
      setTestMsg('Fehler: ' + (err.response?.data?.error || 'Unbekannter Fehler'));
    } finally {
      setTesting(false);
    }
  };

  if (loading) return <div className="card"><div className="loading-spinner" style={{ margin: '1rem auto' }} /></div>;

  return (
    <div className="card">
      <h3 style={{ fontWeight: 700, marginBottom: '0.25rem', color: 'var(--primary)' }}>E-Mail-Konfiguration (SMTP)</h3>
      <p style={{ fontSize: '0.82rem', color: 'var(--text-muted)', marginBottom: '1.25rem' }}>
        Konfiguration für den ausgehenden E-Mail-Versand. Nur für Administratoren sichtbar.
      </p>

      {error && <div className="alert alert-error">{error}</div>}
      {success && <div className="alert alert-success">{success}</div>}

      <form onSubmit={handleSave}>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0 1rem' }}>
          <div className="form-group" style={{ gridColumn: '1 / -1' }}>
            <label className="form-label">SMTP-Server (Host)</label>
            <input type="text" name="smtp_host" value={form.smtp_host} onChange={handleChange}
              className="form-control" placeholder="z.B. smtp.gmail.com oder mail.example.de" />
          </div>
          <div className="form-group">
            <label className="form-label">Port</label>
            <input type="number" name="smtp_port" value={form.smtp_port} onChange={handleChange}
              className="form-control" placeholder="587" />
          </div>
          <div className="form-group" style={{ display: 'flex', alignItems: 'flex-end', paddingBottom: '0.75rem' }}>
            <div>
              <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', cursor: 'pointer', fontSize: '0.9rem' }}>
                <input type="checkbox" name="smtp_secure" checked={form.smtp_secure} onChange={handleChange}
                  style={{ width: 16, height: 16 }} />
                SSL/TLS
              </label>
              <div style={{ fontSize: '0.72rem', color: 'var(--text-muted)', marginTop: '0.3rem' }}>
                {form.smtp_secure
                  ? '→ Port 465, direktes SSL/TLS'
                  : '→ Port 587, STARTTLS (empfohlen)'}
              </div>
            </div>
          </div>
          <div className="form-group">
            <label className="form-label">SMTP-Benutzername</label>
            <input type="text" name="smtp_benutzer" value={form.smtp_benutzer} onChange={handleChange}
              className="form-control" placeholder="user@example.de" autoComplete="off" />
          </div>
          <div className="form-group">
            <label className="form-label">
              SMTP-Passwort{config?.smtp_passwort_gesetzt && <span style={{ fontSize: '0.75rem', color: 'var(--text-muted)', marginLeft: 6 }}>(gesetzt – leer lassen = unverändert)</span>}
            </label>
            <input type="password" name="smtp_passwort" value={form.smtp_passwort} onChange={handleChange}
              className="form-control" autoComplete="new-password" />
          </div>
          <div className="form-group">
            <label className="form-label">Absender Name</label>
            <input type="text" name="absender_name" value={form.absender_name} onChange={handleChange}
              className="form-control" placeholder="SV Grevenbroich" />
          </div>
          <div className="form-group">
            <label className="form-label">Absender E-Mail</label>
            <input type="email" name="absender_email" value={form.absender_email} onChange={handleChange}
              className="form-control" placeholder="info@svgrevenbroich.de" />
          </div>
        </div>

        {/* Vereinsidentität */}
        <div style={{ gridColumn: '1 / -1', marginTop: '0.5rem', paddingTop: '1rem', borderTop: '1px solid var(--border)' }}>
          <div style={{ fontWeight: 700, fontSize: '0.82rem', color: 'var(--primary)', marginBottom: '0.75rem', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
            Vereinsidentität im E-Mail-Template
          </div>
        </div>
        <div className="form-group" style={{ gridColumn: '1 / -1' }}>
          <label className="form-label">Vereinsname (im E-Mail-Header)</label>
          <input type="text" name="vereinsname" value={form.vereinsname} onChange={handleChange}
            className="form-control" placeholder="SV Grevenbroich e.V." />
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0 1rem' }}>
          <div className="form-group">
            <label className="form-label">Ansprechpartner für Rückfragen</label>
            <input type="text" name="kontakt_name" value={form.kontakt_name} onChange={handleChange}
              className="form-control" placeholder="Schwimmadmin" maxLength={200} />
          </div>
          <div className="form-group">
            <label className="form-label">E-Mail des Ansprechpartners</label>
            <input type="email" name="kontakt_email" value={form.kontakt_email} onChange={handleChange}
              className="form-control" placeholder="schwimmadmin@sv-grevenbroich.de" maxLength={255} />
          </div>
        </div>
        <p style={{ fontSize: '0.75rem', color: 'var(--text-muted)', margin: '-0.4rem 0 0.9rem' }}>
          Steht in der Fußzeile jeder E-Mail und auf der Antwortseite für Platzangebote.
          An diese Adresse geht außerdem eine Benachrichtigung, sobald Eltern ein Platzangebot beantworten.
        </p>
        <div className="form-group">
          <label className="form-label">Link zum Aufnahmeantrag (PDF)</label>
          <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
            <input type="url" name="aufnahmeantrag_url" value={form.aufnahmeantrag_url} onChange={handleChange}
              className="form-control" placeholder="https://sv-grevenbroich.de/…/Aufnahmeantrag.pdf" maxLength={500} />
            {form.aufnahmeantrag_url && (
              <a href={form.aufnahmeantrag_url} target="_blank" rel="noopener noreferrer" className="btn btn-secondary btn-sm"
                style={{ whiteSpace: 'nowrap' }}>Prüfen</a>
            )}
          </div>
          <p style={{ fontSize: '0.75rem', color: 'var(--text-muted)', marginTop: '0.35rem' }}>
            Wird in der Platzangebot-Mail, auf der Antwortseite der Eltern und in der Trainer-App verlinkt.
            Ändert sich das PDF auf der Webseite (neue Adresse), hier den neuen Link eintragen – ein Neustart ist nicht nötig.
          </p>
        </div>
        <div className="form-group" style={{ gridColumn: '1 / -1' }}>
          <label className="form-label">Vereins-Logo</label>
          {form.logo_base64 && (
            <div style={{ marginBottom: '0.625rem', padding: '0.75rem', background: '#001A3E', borderRadius: 8, display: 'inline-block' }}>
              <img src={form.logo_base64} alt="Logo-Vorschau" style={{ height: 48, width: 'auto', display: 'block' }} />
            </div>
          )}
          <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center', flexWrap: 'wrap' }}>
            <label style={{
              display: 'inline-flex', alignItems: 'center', gap: '0.4rem',
              padding: '0.45rem 0.875rem', background: 'var(--bg-light)',
              border: '1px solid var(--border)', borderRadius: 'var(--radius)',
              cursor: 'pointer', fontSize: '0.875rem', fontWeight: 600,
            }}>
              📁 Logo-Datei wählen…
              <input type="file" accept="image/*" style={{ display: 'none' }}
                onChange={e => {
                  const file = e.target.files[0];
                  if (!file) return;
                  const reader = new FileReader();
                  reader.onload = ev => setForm(prev => ({ ...prev, logo_base64: ev.target.result }));
                  reader.readAsDataURL(file);
                  e.target.value = '';
                }} />
            </label>
            {form.logo_base64 && (
              <button type="button" className="btn btn-secondary btn-sm"
                onClick={() => setForm(prev => ({ ...prev, logo_base64: '' }))}>
                Logo entfernen
              </button>
            )}
          </div>
          <p style={{ fontSize: '0.75rem', color: 'var(--text-muted)', marginTop: '0.35rem' }}>
            PNG mit transparentem Hintergrund empfohlen. Das Logo wird direkt ins E-Mail-Template eingebettet (kein externer Link).
          </p>
        </div>

        <div className="form-group" style={{ gridColumn: '1 / -1' }}>
          <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', cursor: 'pointer', fontSize: '0.9rem' }}>
            <input type="checkbox" name="aktiv" checked={form.aktiv} onChange={handleChange}
              style={{ width: 16, height: 16 }} />
            <strong>E-Mail-Versand aktivieren</strong>
          </label>
          {!form.aktiv && (
            <p style={{ fontSize: '0.78rem', color: '#888', marginTop: '0.25rem', marginLeft: '1.5rem' }}>
              Solange deaktiviert, werden keine E-Mails versendet.
            </p>
          )}
        </div>

        <button type="submit" className="btn btn-primary" style={{ gridColumn: '1 / -1' }} disabled={saving}>
          {saving ? 'Speichern…' : 'Konfiguration speichern'}
        </button>
      </form>

      {/* Test-E-Mail */}
      <div style={{ marginTop: '1.5rem', paddingTop: '1rem', borderTop: '1px solid var(--border)' }}>
        <div style={{ fontWeight: 600, marginBottom: '0.5rem', fontSize: '0.9rem' }}>Test-E-Mail senden</div>
        <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap' }}>
          <input type="email" value={testAn} onChange={e => setTestAn(e.target.value)}
            className="form-control" placeholder="test@example.de"
            style={{ flex: 1, minWidth: 200 }} />
          <button className="btn btn-secondary" onClick={handleTest} disabled={testing || !testAn}>
            {testing ? 'Sende…' : 'Test senden'}
          </button>
        </div>
        {testMsg && (
          <div className={`alert ${testMsg.startsWith('Fehler') ? 'alert-error' : 'alert-success'}`}
            style={{ marginTop: '0.5rem' }}>
            {testMsg}
          </div>
        )}
      </div>
    </div>
  );
}
